import {
    HorizAlignment, ISearch, ISearchProfile, ISearchProvider,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Connection_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_CONNECTION_ID:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CONNECTION_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CONNECTION_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var ConnectionSearchProviderBasic: ISearchProvider = {

  keyFields: {id:    'WB_CONNECTION_ID',
              id_ui: 'CONNECTION_ID',
              name:  'CONNECTION_NAME'},

  searchProviderFields: vUI_Connection_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Connection_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var ConnectionSearchProfileByName: ISearchProfile = {
  profileId: "default",
  profileName: "Search by Id, Name",
  renderOptions: { ui5ResourceId: "ConnectionSearchProfileByName" },

  profileFilter: [
    {profileFilterName: 'Id',     searchProviderFieldId: 'CONNECTION_ID',   renderOptions: { }},
    {profileFilterName: 'Name',   searchProviderFieldId: 'CONNECTION_NAME', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'CONNECTION_NAME','CONNECTION_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
  ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider: ConnectionSearchProviderBasic,

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}


var ConnectionSearch: ISearch = {
  searchName: "Find Connection",
  renderOptions: { ui5ResourceId: "ConnectionSearch"},
  searchProfileIdDefault: "default",
  searchProfiles: [ConnectionSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("ConnectionBO", "Connection", ConnectionSearch, "Connection Search")

export {ConnectionSearch}
